<template>
  <v-container fluid>
    <v-row class="text-center" align="center" justify="center">
      <v-col cols="12" md="6">
        <h1 class="text-start grey--text text--darken-2 mb-3">
          Live Better with Less Clutter
        </h1>
        <p class="text-start grey--text text--darken-2">
          How can you focus when you’re too busy drowning in a sea of stuff?
          Whether it be your closet or office space, having too many things
          prevents us from making time for what matters most.
        </p>
        <p class="text-start grey--text text--darken-2">
          When you clear up your space, you get closer to living the life you
          want: less mess, and more productivity.
        </p>
        <p class="text-start grey--text text--darken-2">
          But it’s not so easy to let go of your things. You might need them in
          the future, or keep them for sentimental value. This is where we come
          in.
        </p>
        <div class="my-2 text-left">
          <v-btn large color="primary"@click="$vuetify.goTo('form', {offset: 120})"
            >Get Started</v-btn
          >
        </div>
      </v-col>
      <v-col cols="12" md="4" offset-md="1">
        <v-img :src="require('../assets/obra-landing-about_us.png')" contain />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Landing1Hero",
  data: () => ({}),
};
</script>
